import i18n from 'shared/lib/i18n';

import {
  GET_ITEMS_FOR_EXPORT_SUCCESS,
  GET_PERSON_LIST_FAILURE,
  GET_PERSON_LIST_REQUEST,
  GET_PERSON_LIST_SUCCESS,
  SET_MODAL_TYPE,
  WIPE_PERSON_DATA_FAILURE,
  WIPE_PERSON_DATA_REQUEST,
  WIPE_PERSON_DATA_SUCCESS,
} from '../../actionConstants';

import { getFullName } from '../Person/utils';

import apiClient from '../../apiClient';
import { CONFIRM } from '../Modal/modalTypes';

export const getPersons = (dispatch, queryParams, config = {}) => {
  const { isGlobalPersonSearch, isExport } = config;
  const fetchUrl = isGlobalPersonSearch
    ? apiClient.admin.globalPersonSearch
    : apiClient.admin.allPersons;

  return dispatch({
    type: GET_PERSON_LIST_REQUEST,
    withoutLoading: isExport,
    payload: fetchUrl(queryParams).then(
      (res) => {
        dispatch({
          type: isExport
            ? GET_ITEMS_FOR_EXPORT_SUCCESS
            : GET_PERSON_LIST_SUCCESS,
          res,
        });
        return res;
      },
      (err) => dispatch({ type: GET_PERSON_LIST_FAILURE, err }),
    ),
  });
};

const wipePersonData = (dispatch, personId) =>
  dispatch({
    type: WIPE_PERSON_DATA_REQUEST,
    payload: apiClient.admin.wipePersonData(personId).then(
      (res) => dispatch({ type: WIPE_PERSON_DATA_SUCCESS, res }),
      (err) => dispatch({ type: WIPE_PERSON_DATA_FAILURE, err }),
    ),
  });

export const onWipePersonData = (dispatch, person, getItems, listParams) => {
  const name = getFullName(person);
  const modalProps = {
    bodyText: i18n.t('user.deleteNote', { name }),
    confirmText: i18n.t('user.permanentlyDelete'),
    cancelText: i18n.t('actions.cancel'),
    onConfirm: async () => {
      await wipePersonData(dispatch, person?.id);
      return getItems(listParams);
    },
  };
  dispatch({
    type: SET_MODAL_TYPE,
    modalType: CONFIRM,
    modalProps,
  });
};
